<template>
  <v-app-bar app dark color="primary">
    <v-toolbar-title>vue-common-confirm Demo</v-toolbar-title>
  </v-app-bar>
</template>
<script>
export default {
  name: "HeaderBar"
};
</script>
